/******* Angular Resourse *******/
import { Inject, Injectable, Optional } from '@angular/core';
import { BaseApi } from '@api/base/base.service';
import { HttpClient } from '@angular/common/http';
import { ConnectionLogSummaryRequestBody } from '@core/types';

@Injectable()
export class ConnectionLog extends BaseApi {

    constructor(@Inject(HttpClient) protected http: HttpClient) {
        super(http);
    }

    /**
     * GET /connection-log/summary - get ranking of connection-log
     * 
     * @param {ConnectionLogSummaryRequestBody} data
     */
    public getRankingDeviceConnectionDrop(data: ConnectionLogSummaryRequestBody) {

        let method = "GET",
            url = "connection-log/summary",
            routeParams = {},
            urlParams = data,
            postBody = {};

        return this.request(method, url, routeParams, urlParams, postBody);
    }

    /**
     * GET /devices/{MAC}/connection-log - get connection-log by MAC
     * 
     * @param {string} MAC
     */
    public getConnectionLogByMac(MAC: string) {

        let method = "GET",
            url = "devices/{MAC}/connection-log",
            routeParams = { MAC },
            urlParams = {},
            postBody = {};

        return this.request(method, url, routeParams, urlParams, postBody);
    }

}